module.exports = __webpack_public_path__ + "static/media/mask.ea643d9b.png";